import { render, staticRenderFns } from "./HeadContLayer.vue?vue&type=template&id=0b80e3b2&"
import script from "./HeadContLayer.vue?vue&type=script&lang=js&"
export * from "./HeadContLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b80e3b2')) {
      api.createRecord('0b80e3b2', component.options)
    } else {
      api.reload('0b80e3b2', component.options)
    }
    module.hot.accept("./HeadContLayer.vue?vue&type=template&id=0b80e3b2&", function () {
      api.rerender('0b80e3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/components/layer/HeadContLayer.vue"
export default component.exports